import React from 'react';

import notifications from 'notifications';
import {DropdownSearchType, ListableItem} from 'search/SearchConstants';
import {DEFAULT_DROPDOWN_SEARCH_LIMIT} from 'ui-library/dropdowns/SearchDropdownConstants';
import * as net from 'util/Net';
import {ElementKeyboardEvent} from 'util/Types';

import {SelectAttachment} from './AttachDropdownOptionsMenu';
import SearchDropdown, {SearchResultInfo} from './SearchDropdown';

interface FileSearchDropdownProps {
  fileType?: string;
  query: string;
  width?: string | number;
  selectAttachment: SelectAttachment;
}

const SEARCH_ENDPOINT = '/1/api/all/search';

export default class FileSearchDropdown extends React.Component<FileSearchDropdownProps> {
  searchDropdownRef = React.createRef<SearchDropdown>();

  private extendResult(result: ListableItem): {item_id: string; item: ListableItem} & ListableItem {
    return {
      item_id: result.id,
      item: result,
      ...result,
    };
  }

  private handleDoSearch = (query: string, searchResultsCallback: (info: SearchResultInfo) => void): void => {
    const searchArgs = {
      q: query,
      filter: this.props.fileType,
    };
    net
      .getJSON(SEARCH_ENDPOINT, searchArgs)
      .done((response) => {
        searchResultsCallback({
          query,
          limit: DEFAULT_DROPDOWN_SEARCH_LIMIT,
          results: response.data.map((result: ListableItem) => this.extendResult(result)),
          errorMessage: null,
        });
      })
      .fail((resp) => {
        const errorMessage = notifications.getFriendlyError(resp) || 'An error occurred.';
        searchResultsCallback({query, limit: DEFAULT_DROPDOWN_SEARCH_LIMIT, results: [], errorMessage});
      });
  };

  queryKeydownHandler(e: ElementKeyboardEvent): boolean | undefined {
    return this.searchDropdownRef.current?.queryKeydownHandler(e);
  }

  render(): JSX.Element {
    return (
      <SearchDropdown
        ref={this.searchDropdownRef}
        doSearch={this.handleDoSearch}
        profilerTrackingParams={{
          url: SEARCH_ENDPOINT,
          searchType: DropdownSearchType.ENTITY_LINK,
        }}
        {...this.props}
      />
    );
  }
}
